import { denominacionApi } from '@/api'
import {
  DenominacionComboInterface,
  DenominacionFiltroModel,
  DenominacionInterface,
  IResponseElement,
  IResponseMessage,
} from '@/models'

const useDenominacionEndpoint = () => {
  const deleteDenominacion = async (denominacionId: any) => {
    try {
      const { data } = await denominacionApi.get<IResponseMessage>(`delete/${denominacionId}`)

      return { ok: true, response: data }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  const find = async (context: DenominacionFiltroModel) => {
    try {
      const { data } = await denominacionApi.post<IResponseElement<DenominacionInterface>>(`find`, context)

      return { ok: true, response: data }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  const get = async (denominacionId: any) => {
    try {
      const { data } = await denominacionApi.get<DenominacionInterface>(`get/${denominacionId}`)

      return { ok: true, response: data }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  const init = async () => {
    try {
      const { data } = await denominacionApi.get<DenominacionComboInterface>(`init`)

      return { ok: true, response: data }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  const initForm = async () => {
    try {
      const { data } = await denominacionApi.get<DenominacionInterface>(`initForm`)

      return { ok: true, response: data }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  const saveOrUpdate = async (context: DenominacionInterface) => {
    try {
      const { data } = await denominacionApi.post<IResponseMessage>(`saveOrUpdate`, context)

      return { ok: true, response: data }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  return {
    deleteDenominacion,
    find,
    get,
    init,
    initForm,
    saveOrUpdate,
  }
}

export default useDenominacionEndpoint
